notifications-items-common
  a.media(href="{opts.href}")
    i.feather.icon-user.bg-c-green
    .media-body(class="{unread: opts.unread}")
      h5.notification-title { opts.title }
      p.notification-msg { opts.content }
      span.notification-time { ago() }
  script(type="typescript").
    this.mixin('notifications.items.item');
